import { render, staticRenderFns } from "./FactFindWidget.vue?vue&type=template&id=039b9b92&"
import script from "./FactFindWidget.vue?vue&type=script&lang=ts&"
export * from "./FactFindWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports